import { IBorrowingRulesResponse } from "types/BenefitFallbacks/BenefitFallbacks";

import { api } from ".";

/**
 * CLE-3047 — Eligibility › Fallbacks’ "How fallbacks work" section: which service line's
 * co-insurance is borrowed from which, summarised from every hospital's live benefit map. READ
 * ONLY, SuperAdmin only on the API. The map changes when a hospital's benefit selection screen is
 * saved or the map is re-seeded, so the page refetches each time it is opened
 * (`refetchOnMountOrArgChange` at the call site) rather than relying on another screen's tags.
 */
const apiWithBenefitFallbackTags = api.enhanceEndpoints({
  addTagTypes: ["BenefitFallbacks"],
});

export const BENEFIT_FALLBACKS_PATH = "eligibility/benefit-fallbacks";

export const benefitFallbackQueries =
  apiWithBenefitFallbackTags.injectEndpoints({
    endpoints: (builder) => ({
      getBorrowingRules: builder.query<IBorrowingRulesResponse, void>({
        query: () => BENEFIT_FALLBACKS_PATH,
        transformResponse: (response: { data: IBorrowingRulesResponse }) =>
          response.data,
        providesTags: [{ type: "BenefitFallbacks", id: "LIST" }],
      }),
    }),
  });

export const { useGetBorrowingRulesQuery } = benefitFallbackQueries;
